import axiosInstance from './axiosInstance';

/**
 * Client-side face capture (only where the clinic's policy allows it).
 * BACKEND: /user/face-capture/*
 */

/** GET /user/face-capture/invite/:id -> { clinicCode, clinicName, agentKey, agentName } */
export async function getInvite(inviteId) {
  const res = await axiosInstance.get(`/user/face-capture/invite/${encodeURIComponent(inviteId)}`);
  return res.data.data;
}
/** GET /user/face-capture/policy?clinicCode= */
export async function getPolicy(clinicCode) {
  const res = await axiosInstance.get('/user/face-capture/policy', { params: { clinicCode } });
  return res.data.data;
}
/** POST /user/face-capture/start { clinicCode, agentKey?, capturedAt, device } */
export async function startCapture(payload) {
  const res = await axiosInstance.post('/user/face-capture/start', payload);
  return res.data.data;
}
/** POST /user/face-capture/:id/poses */
export async function uploadPose(analysisId, pose) {
  const res = await axiosInstance.post(`/user/face-capture/${analysisId}/poses`, pose);
  return res.data.data;
}
/** POST /user/face-capture/:id/complete */
export async function completeCapture(analysisId) {
  const res = await axiosInstance.post(`/user/face-capture/${analysisId}/complete`);
  return res.data.data;
}

export const faceCaptureApi = { getInvite, getPolicy, startCapture, uploadPose, completeCapture };
export default faceCaptureApi;
